/**
 * 创作者中心- 模型详情
 * @returns
 */
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import modelImg1 from "@/assets/images/creator_model_img1.png";
import modelImg2 from "@/assets/images/creator_model_img2.png";

import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  HStack,
  Divider,
  Image,
  IconButton,
  Avatar,
  Center,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Radio,
  Textarea,
  Input,
  Checkbox,
  SimpleGrid,
  useDisclosure,
  Progress,
} from "@chakra-ui/react";
import {
  RiArrowLeftWideLine,
  RiArrowRightWideLine,
  RiBox3Line,
  RiDeleteBin4Line,
  RiDownload2Line,
  RiEditBoxLine,
  RiRefreshLine,
  RiStarLine,
  RiThumbUpLine,
  RiUpload2Line,
  RiUploadCloud2Line,
  RiUserLine,
} from "@remixicon/react";
import { useCallback, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./modelSlick.css";
import { ModelPreview, MyModel } from "@/types/creatorcenter";
import viplevel from "@/assets/viplevel.png";
import medal from "@/assets/medal.png";
import onekeyG from "@/assets/images/onekeygrey.svg";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import intergralIcon from "@/assets/images/icon_integral.png";
import ContentComment from "../contentdetail/contentcomment";
import TrainingResultModalItem from "./trainingResultModalItem";
import modelImg from "@/assets/images/creator_model_img1.png";
import EditModelDetailModal from "./editModelDetailModal";
import { useLazyGetTrainByIdQuery } from "@/services/api/endpoints/model";
import {
  selectCurrentTrainId,
  selectTrainingParams,
  updateModelcovers,
  updateModelPublishParams,
} from "@/reducer/mymodelSlice";
import { useNavigate } from "react-router-dom";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  handleOpenPublish: () => void;
};

let timer: any;
const TraingResultModal = (props: Props) => {
  const { isOpen, onClose, handleOpenPublish } = props;
  const navigate = useNavigate();
  const sliderRef = useRef<Slider>(null);
  const user = useSelector(selectUser);
  const dispatch = useAppDispatch();

  const trainingParams = useAppSelector(selectTrainingParams);

  // const editControl = useDisclosure();
  const currentTrainId = useAppSelector(selectCurrentTrainId);
  const [isCheckedAll, setIsCheckedAll] = useState<boolean>(false);
  const [images, setImages] = useState<ModelPreview[]>([]);
  const [trainStatus, setTrainStatus] = useState<string>("");
  const [count, setCount] = useState(0);
  const [progress, setProgress] = useState(0);
  const imagesChecked = images.filter((item) => item.isChecked === true);

  const [getTrainById] = useLazyGetTrainByIdQuery();

  // 计算保存的LoRA数量
  const LoRANums = Math.floor(
    trainingParams.max_train_epochs / trainingParams.save_every_n_epochs
  );

  useEffect(() => {
    const progressNow = Number((images.length / LoRANums).toFixed(2)) * 100;
    setProgress(progressNow);
  }, [images]);

  // 获取训练
  const getTrainByIdFunc = async () => {
    let result = (await getTrainById({ train_id: currentTrainId })).data!;
    setCount(result.count);
    const train = result.train;
    setTrainStatus(train.train_status);
    if (train.preview) {
      const newImage = train.preview.map((item) => {
        return {
          preview: item,
          isChecked: false,
        };
      });
      setImages(newImage);
    }
    if (train?.train_status === "训练完成") {
      clearInterval(timer);
      setProgress(100);
      dispatch(updateModelPublishParams(train));
      dispatch(updateModelcovers(train.preview));
    }
  };

  useEffect(() => {
    if (isOpen) {
      timer = setInterval(() => getTrainByIdFunc(), 5000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [isOpen]);

  const handleEditModelDetail = () => {
    clearInterval(timer);
    const previewImages = images.map((item) => {
      return item.preview;
    });
    if (previewImages.length === images.length) {
      dispatch(updateModelcovers(previewImages));
      onClose();
      handleOpenPublish();
    }
  };

  const handleCheckBox = (
    e: React.ChangeEvent<HTMLInputElement>,
    preview: string
  ) => {
    let newImages = [...images];
    newImages.map((item) => {
      if (item.preview === preview) {
        item.isChecked = e.target.checked;
        return;
      }
    });
    setImages(newImages);
  };

  const handleCheckAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsCheckedAll(e.target.checked);
    let newImages = [...images];
    newImages.map((item) => (item.isChecked = e.target.checked));
    setImages(newImages);
  };

  const handleTrainAgain = () => {
    // clearInterval(timer);
    onClose();
  };

  const generateRandomCode = (length: number): string => {
    let code = "";
    for (let j = 0; j < length; j++) {
      code += Math.floor(Math.random() * 10); // 生成 0-9 之间的随机数
    }
    return code;
  };

  const handleDownload = useCallback(() => {
    if (!imagesChecked.length) {
      return;
    }
    imagesChecked.map(async (item) => {
      try {
        const response = await fetch(item.preview as string);
        const blob = await response.blob();
        const link = document.createElement("a") as HTMLAnchorElement;
        link.href = URL.createObjectURL(blob);
        link.download = generateRandomCode(9) + ".png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error fetching the image", error);
      }
    });
  }, [imagesChecked.length]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg="#fff" h="100vh">
        <ModalHeader>
          <Flex justifyContent={"space-between"} alignItems="center" mr="60px">
            <HStack spacing={0}>
              <Text color="#27314D" fontSize={"18px"}>
                模型训练
              </Text>
              {trainStatus === "已创建" && (
                <Text ml="20px" fontSize={"14px"}>
                  {count > 0
                    ? `正在排队中，前面有${count}位`
                    : "正在训练中...,请稍等"}
                </Text>
              )}
              {trainStatus === "训练中" && (
                <Flex ml="20px" w="260px" alignItems={"center"}>
                  <Box flex={1}>
                    <Progress value={progress} />
                  </Box>
                  <Box ml="10px" fontSize={"14px"}>{progress}%</Box>
                </Flex>
              )}
            </HStack>
            <Flex alignItems={"center"} gap="10px">
              <Button
                borderRadius={0}
                height={"40px"}
                color="#27314D"
                bg="rgba(238, 241, 247, 0.5)"
                fontWeight={"normal"}
                fontSize="14px"
                _hover={{
                  bg: "rgba(238, 241, 247, 0.5)",
                }}
                leftIcon={<RiRefreshLine size={"16px"} />}
                position={"relative"}
                onClick={handleTrainAgain}
              >
                再次训练
              </Button>
              <Button
                borderRadius={0}
                height={"40px"}
                color="#FFFFFF"
                bgColor="#496AE1"
                fontWeight={"normal"}
                fontSize="12px"
                _hover={{
                  bgColor: "#3F5BC1",
                  color: "#E6E6E6",
                }}
                leftIcon={<RiEditBoxLine size={"16px"} />}
                position={"relative"}
                isDisabled={trainStatus !== "训练完成"}
                onClick={handleEditModelDetail}
              >
                编辑模型并发布
              </Button>
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody>
          <Flex h={"100%"} gap="20px">
            {/* 左侧 */}
            <Flex
              h="100%"
              flex={1}
              p="12px"
              flexDir="column"
              border="1px solid #DCE0EB"
            >
              <Flex
                mb="14px"
                justifyContent={"space-between"}
                alignItems="center"
              >
                <HStack>
                  <Text color={"#27314D"} fontWeight="bold" fontSize={"16px"}>
                    训练完成
                  </Text>
                  {/* <Text color={"#27314D"} fontWeight="bold" fontSize={"14px"}>
                    LoRA
                  </Text>
                  <Text color={"#496AE1"} fontWeight="bold" fontSize={"14px"}>
                    {" "}
                    5/5
                  </Text> */}
                  {/* <Text color={"#8E94A9"} fontSize={"14px"} ml="20px">
                    本次实际使用算力：657
                  </Text> */}
                </HStack>
                <HStack>
                  <Checkbox isChecked={isCheckedAll} onChange={handleCheckAll}>
                    <Text fontSize={"14px"}>全选</Text>
                  </Checkbox>
                  <Text fontSize={"14px"}>已选 {imagesChecked.length}</Text>
                  {/* <Button
                    borderRadius={0}
                    height={"40px"}
                    color="#27314D"
                    bg="rgba(238, 241, 247, 0.5)"
                    fontWeight={"normal"}
                    fontSize="14px"
                    _hover={{
                      bg: "rgba(238, 241, 247, 0.5)",
                    }}
                    leftIcon={<RiDeleteBin4Line size={"16px"} />}
                  >
                    删除
                  </Button> */}
                  <Button
                    borderRadius={0}
                    height={"40px"}
                    color="#27314D"
                    bg="rgba(238, 241, 247, 0.5)"
                    fontWeight={"normal"}
                    fontSize="14px"
                    _hover={{
                      bg: "rgba(238, 241, 247, 0.5)",
                    }}
                    leftIcon={<RiDownload2Line size={"16px"} />}
                    onClick={handleDownload}
                  >
                    下载
                  </Button>
                </HStack>
              </Flex>
              <Box flex={1} h="0" overflowY={"auto"} position={"relative"}>
                <SimpleGrid columns={4} spacing={"40px 20px"}>
                  {images.map((item) => (
                    <Box key={item.preview}>
                      <TrainingResultModalItem
                        image={item}
                        isCheckedAll={isCheckedAll}
                        handleCheckBox={handleCheckBox}
                      />
                    </Box>
                  ))}
                </SimpleGrid>
              </Box>
            </Flex>
            {/* 右侧 */}
            <Flex
              w="352px"
              h="100%"
              border="1px solid #DCE0EB"
              pt="12px"
              pb="12px"
              boxSizing="border-box"
              flexDirection={"column"}
            >
              <Box
                pl="12px"
                color={"#27314D"}
                fontWeight="bold"
                fontSize={"16px"}
                mb="12px"
              >
                实时样图
              </Box>
              <Box flex={1} h="0" pl="12px" pr={"12px"} overflow={"auto"}>
                <Box bg={"rgba(238, 241, 247, 0.5)"} position="relative">
                  {images.length > 0 && (
                    <Image
                      w="100%"
                      objectFit="contain"
                      src={images[images.length - 1].preview}
                    />
                  )}

                  <Box
                    position={"absolute"}
                    bottom="0px"
                    left={"0px"}
                    w="100%"
                    p="5px 6px"
                    color={"#fff"}
                    fontSize="16px"
                  >
                    <Text>LoRA 01 Step:1100 Epoch:5 </Text>
                    <Text>"one building"</Text>
                  </Box>
                </Box>
              </Box>
            </Flex>
          </Flex>
          {/* <EditModelDetailModal
            isOpen={editControl.isOpen}
            onClose={editControl.onClose}
          /> */}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TraingResultModal;
